import { useEffect, useContext } from 'react';
import ElementSettingsContext from '../helpers/element-settings-context';

const useMountChunk = (
  chunkId,
  {
    tabId = null,
    initialState = {},
    defaultValues = {},
    stageHandlers = null,
    withUnmount = false,
  } = {}
) => {
  const { mountChunk, unmountChunk, isChunkMounted } = useContext(ElementSettingsContext);

  useEffect(() => {
    const mount = async () => {
      try {
        await mountChunk(chunkId, {
          tabId,
          initialState,
          defaultValues,
          stageHandlers,
        });
      } catch (error) {
        console.error('Failed to mount chunk:', error);
      }
    };

    mount();

    return withUnmount ? () => unmountChunk(chunkId) : Function.prototype;

    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return {
    isChunkMounted: isChunkMounted(chunkId),
  };
};

export default useMountChunk;
